import React from 'react'
import Styled from 'styled-components'

const Container = Styled.div`
  padding: ${props => props.theme.spacing.medium.css} 0;
`

const Content = Styled.div`
  width: ${props => props.theme.width.css};
  max-width: calc(100% - ${props => props.theme.spacing.medium.spacing * 2}rem);
  box-shadow: ${props => props.theme.elevation.medium.css};
  border-radius: ${props => props.theme.roundness.medium.css};
  padding: ${props => props.theme.spacing.medium.css};
  margin: 0 auto;
`

const Card = Styled.div`
  display: block;
  width: 42rem;
  max-width: calc(100% - 2rem); 
  margin: 3rem auto;
  line-height: 1;
  font-family: ${props => props.theme.fonts.primary.css};
  color: ${props => props.theme.colors.black.shade500.css};
  background-color: ${props => props.theme.colors.white.shade100.css};
`

const SmallCard = Styled(Card)`
  box-shadow: ${props => props.theme.elevation.small.css};
  border-radius: ${props => props.theme.roundness.small.css};
  padding: ${props => props.theme.spacing.small.css};
  margin: ${props => props.theme.spacing.small.css} auto;
`

const MediumCard = Styled(Card)`
  box-shadow: ${props => props.theme.elevation.medium.css};
  border-radius: ${props => props.theme.roundness.medium.css};
  padding: ${props => props.theme.spacing.medium.css};
  margin: ${props => props.theme.spacing.medium.css} auto;
`

const LargeCard = Styled(Card)`
  box-shadow: ${props => props.theme.elevation.large.css};
  border-radius: ${props => props.theme.roundness.large.css};
  padding: ${props => props.theme.spacing.large.css};
  margin: ${props => props.theme.spacing.large.css} auto;
`

const Colors = Styled.div`
  text-align: center;
`

const Color = Styled.div`
  display: inline-block;
  height: 3rem;
  width: 3rem;
  margin: 0.5rem;
  background-color: ${props => props.theme.colors[props.variant][props.shade].css};
  box-shadow: ${props => props.theme.elevation.medium.css};
  border-radius: ${props => props.theme.roundness.small.css};
`

export default ({ attrs, theme }) => (
  <Container>
    <Content>
      <Colors>
        {[100, 200, 300, 400, 500].map((n) => (
          <Color key={n} variant="primary" shade={`shade${n}`} />
        ))}
      </Colors>

      <Colors>
        {[100, 200, 300, 400, 500].map((n) => (
          <Color key={n} variant="gray" shade={`shade${n}`} />
        ))}
      </Colors>

      <Colors>
        {[100, 200, 300, 400, 500].map((n) => (
          <Color key={n} variant="white" shade={`shade${n}`} />
        ))}
      </Colors>

      <Colors>
        {[100, 200, 300, 400, 500].map((n) => (
          <Color key={n} variant="black" shade={`shade${n}`} />
        ))}
      </Colors>

      <SmallCard>
        Small
        <pre>
          {JSON.stringify(theme.fonts, null, 2)}
        </pre>
      </SmallCard>

      <MediumCard>
        Medium
      </MediumCard>
      
      <LargeCard>
        Large
      </LargeCard>
    </Content>
  </Container>
)


// WEBPACK FOOTER //
// ./src/shared/components/Text/index.js